<mat-accordion *ngIf="isReady">
  <mat-expansion-panel *ngFor="let section of itemsSections; let i = index" hideToggle [expanded]="false" (opened)="onPanelOpened(i)">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ section.sectionName }}</mat-panel-title>
      <i class="fal fa-trash-alt tg-custom-icon" (click)="removeSection(i)"></i>
    </mat-expansion-panel-header>
    <app-generic-items-section [section]="section" [items]="section.items" [uncategorizedItems]="uncategorizedItems"
      (sectionChange)="onSectionChange($event, section)" (addItem)="onAddItem(section, $event)"
      (removeItem)="onRemoveItem(section, $event)" [reset]="reset.bind(this)" #itemsSectionRef>
    </app-generic-items-section>
  </mat-expansion-panel>

  <div class="add-section">
    <teiasoft-button class="add-section-btn" [text]="'quotation.addItemsSection' | translate" [theme]="theme"
      [isMobile]="isMobile" (onClick)="addNewSection()" [disabled]="false"></teiasoft-button>
  </div>
</mat-accordion>
<ng-template #promptTemplate let-dialogRef="dialogRef">
  <div class="dialog">
    <div class="td-cnt-title">
      <span class="te-title">
        {{ 'quotation.addItemsSection' | translate }}
      </span>
    </div>
    <div class="td-cnt-body-ds">
      <teiasoft-input [type]="'text'" [labelText]="'quotation.sectionName' | translate" [isMobile]="isMobile"
        [isRequired]="true" [disabled]="false" [value]="newSectionName" (onInput)="onInputSectionName($event)"
        [readOnly]="false"></teiasoft-input>
    </div>
    <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close()" [text]="'commons.cancel' | translate" [theme]="theme"
        [isMobile]="isMobile"></teiasoft-button>
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close(newSectionName)" [text]="'commons.add' | translate"
        [theme]="theme" [isMobile]="isMobile" [disabled]="!newSectionName || newSectionName === '' || !newSectionIsValid"></teiasoft-button>
    </div>
  </div>
</ng-template>

<ng-template #confirmTemplate let-dialogRef="dialogRef">
  <div class="dialog">
    <div class="td-cnt-title">
      <span class="te-title">
        {{ 'quotation.removeItemSection' | translate }}
      </span>
    </div>
    <div class="td-cnt-body-ds">
      {{ 'quotation.confirmRemove' | translate }}
    </div>
    <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close(false)" [text]="'commons.no' | translate" [theme]="theme"
        [isMobile]="isMobile"></teiasoft-button>
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close(true)" [text]="'commons.yes' | translate" [theme]="theme"
        [isMobile]="isMobile"></teiasoft-button>
    </div>
  </div>
</ng-template>